import client from "services/ngage/api-client";
import {PhysicalObject, PhysicalObjectData} from "types/PhysicalObject";
import DataPage from "types/DataPage";
import deserializePhysicalObject from "services/ngage/deserializers/physical-object";
import {queryString} from "services/string";

/**
 * Get all objects (paginated)
 */
const all = async (page: number = 1, perPage: number = 100) => {
    const query = queryString({page, per_page: perPage})
    const response = await client.get<DataPage<PhysicalObject> | null>(`/objects?${query}`)

    if (response.data) {
        response.data.data = response.data.data.map(deserializePhysicalObject)
    }

    return response.data
}

/**
 * Get a single physical object
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<PhysicalObject | null>(`/objects/${id}`)
    return response.data ? deserializePhysicalObject(response.data) : null
}

/**
 * Store a new physical object
 *
 * @param data
 */
const store = async (data: PhysicalObjectData) => {
    const response = await client.post<PhysicalObject | null>('/objects', data)
    return response.data ? deserializePhysicalObject(response.data) : null
}

/**
 * Update an existing physical object
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: PhysicalObjectData) => {
    const response = await client.put<PhysicalObject | null>(`/objects/${id}`, data)
    return response.data ? deserializePhysicalObject(response.data) : null
}

/**
 * Permanently delete a object
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/objects/${id}`)
    return response.status === 204
}

const objects = {
    all,
    get,
    store,
    update,
    destroy
}

export default objects;